module.exports = __webpack_public_path__ + "img/area-comum-07.6948e4d9.png";